import styled from 'styled-components';
import { colors } from '../../styles/variables';

const StyledButton = styled.button`
  background: transparent;
  padding: 8px 12px;
  display: block;
  border: none;
  text-align: center;
  font-size: 1rem;
  align-self: center;
  color: ${colors.gray600};
  &:hover {
    color: ${colors.gray800};
  }
`

export const FieldGroup = ({title, index, children, handleRemove, ...props}) => {
  return (
    <div>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem'}}>
        <h4 style={{fontSize: '1rem', marginBottom: 0}}>{title} {index}</h4>
        <StyledButton
            type='button'
            onClick={handleRemove}
          >
            <i className="fas fa-trash" />
        </StyledButton>
      </div>
      {children}
    </div>
  )
}